export default {
    user: {
        name: 'Имя',
        info: 'Информация',
        phone: 'Телефон',
        email: 'E-mail',
        role: 'Роль',
        password: 'Пароль',
    },
};
